import harnessConfig from "@/config/harness"
import HardCoded from "@/services/HardCoded"

/**
 * WARNING:
 * - Popups are disabled here because AI-driven E2E tests
 * need popups disabled to work well.
 */
export const isPopupDisabled = (): boolean => {
	/**
	 * WARNING:
	 * - We do not use 'Hardcoded.checkFeatureFlag' since we want this validation
	 * to be done only for this specific instance, and not for all test instances.
	 */
	const isHomologTestingInstance = HardCoded.instanceId === HardCoded.instanceIdMap.letalk.MOTA_AGENTE_DE_IA
	const isLocalTestingApp = harnessConfig.isPopupDisabled

	return isHomologTestingInstance || isLocalTestingApp
}
